import { render, staticRenderFns } from "./VisitorRealNameSuccess.vue?vue&type=template&id=04c97d80&scoped=true"
import script from "./VisitorRealNameSuccess.vue?vue&type=script&lang=js"
export * from "./VisitorRealNameSuccess.vue?vue&type=script&lang=js"
import style0 from "./VisitorRealNameSuccess.vue?vue&type=style&index=0&id=04c97d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c97d80",
  null
  
)

export default component.exports